import { createAction, props } from '@ngrx/store';

export const dashboardInfo = createAction(
  '[Dashboard] Dashboard Info'
);

export const dashboardInfoSuccess = createAction(
  '[Dashboard] Dashboard Info Success',
  props<{ result: any }>()
);

export const dashboardInfoFailure = createAction(
  '[Dashboard] Dashboard Info Failure',
  props<{ error: any }>()
);

export const services = createAction(
  '[Dashboard] Services'
);

export const servicesSuccess = createAction(
  '[Dashboard] Services Success',
  props<{ result: any }>()
);

export const servicesFailure = createAction(
  '[Dashboard] Services Failure',
  props<{ error: any }>()
);

export const storeService = createAction(
  '[Dashboard] Store Service',
  props<{ serviceId: number, message: string }>()
);

export const storeServiceSuccess = createAction(
  '[Dashboard] Store Service Success',
  props<{ result: any }>()
);

export const storeServiceFailure = createAction(
  '[Dashboard] Store Service Failure',
  props<{ error: any }>()
);

// CSV Upload actions
export const uploadCSV = createAction(
  '[Dashboard] Upload CSV',
  props<{ file: File, batchType: string }>()
);

export const uploadCSVSuccess = createAction(
  '[Dashboard] Upload CSV Success',
  props<{ result: any }>()
);

export const uploadCSVFailure = createAction(
  '[Dashboard] Upload CSV Failure',
  props<{ error: any }>()
);

// Email Upload actions
export const uploadEmails = createAction(
  '[Dashboard] Upload Emails',
  props<{ emails: string[] }>()
);

export const uploadEmailsSuccess = createAction(
  '[Dashboard] Upload Emails Success',
  props<{ result: any }>()
);

export const uploadEmailsFailure = createAction(
  '[Dashboard] Upload Emails Failure',
  props<{ error: any }>()
);
